<template>
<div class="bookcase" >
    <div class="barTop">
        <img class="logo" src="@/assets/img/bookcase/logo.png" alt="">
        <img class="title" src="@/assets/img/bookcase/title.png" alt="">
    </div>
    <div class="bookBox">
        <div class="leftColumn">
        </div>
        <div class="listBox">
            <div class="listTab">
                <van-tabs v-model="active" @change="changeTab" class="tabClass" :class="isPC?'pcText':''">
                    <van-tab title="第一阶段" name="1"></van-tab>
                    <van-tab title="第二阶段" name="2"></van-tab>
                </van-tabs>
            </div>
            <div class="bgMask">
            </div>
            <template v-if="active=='1'">
                <template v-if="isPC">
                    <template v-for="(item, index) in list1">
                        <div class="bookshelfBox lastRow"   :key="index" v-if="index%screenWidth==0">
                            <template v-for="i in screenWidth" >
                                <template v-if="i+(index/screenWidth*screenWidth)<list1.length">
                                    <div class="bookItem"  @click="goLink(list1[i+(index/screenWidth*screenWidth)].link)" :key="'item'+i">

                                        <div class="bookImg">
                                            <div class="bookImgMask"></div>
                                            <img :src="'https://thumb.artron.net/Img/image?w=860&src='+list1[i+(index/screenWidth*screenWidth)].imgUrl" alt="">
                                        </div>
                                        <div  class="bookName">{{list1[i+(index/screenWidth*screenWidth)].name}}   </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <template v-for="(item, index) in list1">
                        <div class="bookshelfBox"   :key="index" v-if="index%2==0">
                            <div class="bookItem"  @click="goLink(item.link)">
                                <div class="bookImg">
                                    <div class="bookImgMask"></div>
                                    <img :src="'https://thumb.artron.net/Img/image?w=860&src='+item.imgUrl" alt="">
                                </div>
                                <div  class="bookName">{{item.name}}</div>
                            </div>
                            <div class="bookItem"  @click="goLink(list1[index+1].link)">
                                <div class="bookImg">
                                    <div class="bookImgMask"></div>
                                    <img :src="'https://thumb.artron.net/Img/image?w=860&src='+list1[index+1].imgUrl" alt="">
                                </div>
                                <div  class="bookName">{{list1[index+1].name}}</div>
                            </div>

                        </div>
                    </template>
                </template>
            </template>
            <template v-else>
                <template v-if="isPC">
                    <template v-for="(item, index) in list2">
                        <div class="bookshelfBox lastRow"   :key="index" v-if="index%screenWidth==0">
                            <template v-for="i in screenWidth" >
                                <template v-if="i+(index/screenWidth*screenWidth)<list2.length">
                                    <div class="bookItem"  @click="goLink(list2[i+(index/screenWidth*screenWidth)].link)" :key="'item'+i">

                                        <div class="bookImg">
                                            <div class="bookImgMask"></div>
                                            <img :src="'https://thumb.artron.net/Img/image?w=860&src='+list2[i+(index/screenWidth*screenWidth)].imgUrl" alt="">
                                        </div>
                                        <div  class="bookName">{{list2[i+(index/screenWidth*screenWidth)].name}}   </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <template v-for="(item, index) in list2">
                        <div class="bookshelfBox"   :key="index" v-if="index%2==0">
                            <div class="bookItem"  @click="goLink(item.link)">
                                <div class="bookImg">
                                    <div class="bookImgMask"></div>
                                    <img :src="'https://thumb.artron.net/Img/image?w=860&src='+item.imgUrl" alt="">
                                </div>
                                <div  class="bookName">{{item.name}}</div>
                            </div>
                            <div class="bookItem"  @click="goLink(list2[index+1].link)">
                                <div class="bookImg">
                                    <div class="bookImgMask"></div>
                                    <img :src="'https://thumb.artron.net/Img/image?w=860&src='+list2[index+1].imgUrl" alt="">
                                </div>
                                <div  class="bookName">{{list2[index+1].name}}</div>
                            </div>

                        </div>
                    </template>
                </template>
            </template>


        </div>
        <div class="rightColumn">
        </div>
        <div class="bookBottom">
            <img style="left: -11px;" src="@/assets/img/bookcase/bottom_left.png" alt="">
            <img src="@/assets/img/bookcase/bottom_mid.png" class="bookBottomImg"/>
            <img style="right: -11px;"  src="@/assets/img/bookcase/bottom_right.png" alt="">
        </div>
    </div>

</div>
</template>

<script>
import {
    getWXConfig
} from '@/assets/js/weixinShare'
import { Tab, Tabs } from 'vant';
export default {
    name: 'bookcase',
    components: {

    },
    data() {
        return {
            isPC:true,
            screenWidth:0,
            active: '0',
            listJson:[{
                name:'瓷器及古董珍玩集萃（瓷器）',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/ciqi/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/4ca17dcdde6eb2ff646ec34ed70c0b2e.jpg'
            },{
                name:'湛园·珍藏',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/zhanyuan/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/514199d6868c211908cf1214833b14a8.jpg'
            },{
                name:'超以象外—宫廷艺术中的诗与画',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/chaoyixiangwai/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/00ec20c624f9ea10b84f8112cb151eb4.jpg'
            },{
                name:'日月光华—明代御瓷珍玩',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/riyueguanghua/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/e801d9c1b743a52e6d157fae8c5d8ab7.jpg'
            },{
                name:'宸赏—明清御瓷珍玩',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/mingqingyuci/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/f5540b615367fb2f7f774a2988bb496e.jpg'
            },{
                name:'玲珑',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/linglong/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/2e89836bfa02e82fa6b2dead3a846cf9.jpg'
            },{
                name:'紫泥菁英—紫砂古器与近现代臻品',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/zinijingying/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/6fdbe3c4a8b6d6e7bc9ea0e6822d9db8.jpg'
            },{
                name:'旃檀林—佛教艺术集萃',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/fojiaoyishu/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/5e09fa7d7e678fc12b82dd1cf093c03d.jpg'
            },{
                name:'瓷器及古董珍玩集萃（玉器 西洋古董 工艺品）',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/yuqizaxiang/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/4ca17dcdde6eb2ff646ec34ed70c0b2e.jpg'
            },{
                name:'清宁——金石篆刻艺术',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/qingning/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/e781c8321cd302e94093e411a3f407f7.jpg'
            },{
                name:'古癖——牧心斋古代文房精选',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/gupi/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/b4e5a302b76baf23036f66f27a060067.jpg'
            },{
                name:'致中和——宫廷艺术珍品',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhizhonghe/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/ed7c3bc5a70a2c2cee41a3da93c63fbe.jpg'
            },{
                name:'乘物——重要私人珍藏竹木文房逸品',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/chengwu/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/e4d88e5f534775540b8c7e9d86b61cf5.jpg'
            },{
                name:'澄怀——金石文房雅玩',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/chenghuaijinshiwenfangyawan/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/5f7aba074696e41ee90a56f16332cf6e.jpg'
            },{
                name:'居木游香——古典家具及沉香木艺',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/jimuyouxiang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/1cb9fde486a37e50d8f6a74a4311770b.jpg'
            },{
                name:'二十世纪及当代艺术',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/ershishijirichang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/68a877eec415a0357ab5eb7dcb52aaad.jpg'
            },{
                name:'二十世纪艺术夜场',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/ershishijyishuyechang/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/6cfbbb7edd88099c338157f08566d0d1.jpg'
            },{
                name:'当代艺术夜场',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/dangdaiyishuyechang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/ea86b2ed0efaa19e377d417b29775a23.jpg'
            },{
                name:'瑰丽珠宝与翡翠',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhubao/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/0a5cee330442847f5ffae045daaf5dee.jpg'
            },{
                name:'名贵钟表',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhongbiao/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/173bbbd7ad93d8263e1d536bbc42adbc.jpg'
            }
            ],
            list1:[{
                name:'瓷器及古董珍玩集萃（瓷器）',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/ciqi/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/4ca17dcdde6eb2ff646ec34ed70c0b2e.jpg'
            },{
                name:'湛园·珍藏',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/zhanyuan/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/514199d6868c211908cf1214833b14a8.jpg'
            },{
                name:'超以象外—宫廷艺术中的诗与画',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/chaoyixiangwai/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/00ec20c624f9ea10b84f8112cb151eb4.jpg'
            },{
                name:'日月光华—明代御瓷珍玩',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/riyueguanghua/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/e801d9c1b743a52e6d157fae8c5d8ab7.jpg'
            },{
                name:'宸赏—明清御瓷珍玩',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/mingqingyuci/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/f5540b615367fb2f7f774a2988bb496e.jpg'
            },{
                name:'玲珑',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/linglong/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/2e89836bfa02e82fa6b2dead3a846cf9.jpg'
            },{
                name:'紫泥菁英—紫砂古器与近现代臻品',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/zinijingying/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/6fdbe3c4a8b6d6e7bc9ea0e6822d9db8.jpg'
            },{
                name:'旃檀林—佛教艺术集萃',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/fojiaoyishu/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/5e09fa7d7e678fc12b82dd1cf093c03d.jpg'
            },{
                name:'瓷器及古董珍玩集萃（玉器 西洋古董 工艺品）',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/yuqizaxiang/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/4ca17dcdde6eb2ff646ec34ed70c0b2e.jpg'
            },{
                name:'清宁——金石篆刻艺术',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/qingning/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/e781c8321cd302e94093e411a3f407f7.jpg'
            },{
                name:'古癖——牧心斋古代文房精选',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/gupi/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/b4e5a302b76baf23036f66f27a060067.jpg'
            },{
                name:'致中和——宫廷艺术珍品',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhizhonghe/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/ed7c3bc5a70a2c2cee41a3da93c63fbe.jpg'
            },{
                name:'乘物——重要私人珍藏竹木文房逸品',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/chengwu/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/e4d88e5f534775540b8c7e9d86b61cf5.jpg'
            },{
                name:'澄怀——金石文房雅玩',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/chenghuaijinshiwenfangyawan/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/5f7aba074696e41ee90a56f16332cf6e.jpg'
            },{
                name:'居木游香——古典家具及沉香木艺',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/jimuyouxiang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/1cb9fde486a37e50d8f6a74a4311770b.jpg'
            },{
                name:'二十世纪及当代艺术',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/ershishijirichang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/68a877eec415a0357ab5eb7dcb52aaad.jpg'
            },{
                name:'二十世纪艺术夜场',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/ershishijyishuyechang/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/6cfbbb7edd88099c338157f08566d0d1.jpg'
            },{
                name:'当代艺术夜场',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/dangdaiyishuyechang/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/ea86b2ed0efaa19e377d417b29775a23.jpg'
            },{
                name:'瑰丽珠宝与翡翠',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhubao/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/0a5cee330442847f5ffae045daaf5dee.jpg'
            },{
                name:'名贵钟表',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhongbiao/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/173bbbd7ad93d8263e1d536bbc42adbc.jpg'
            }
            ],
            list2:[{
                name:'缤纷集—聚焦私人收藏',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/binfenji/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/4b3840753efbc7ccc910516399439519.jpg'
            },{
                name:'四相集',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/sixiangji/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/892a57221fe2c578856a79ee85b4a51a.jpg'
            },{
                name:'大观—中国书画珍品之夜 · 近现代',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/daguanjinxiandai/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/fa957fb77c3061fe4471a43b7bbe54c2.jpg'
            },{
                name:'大观—中国书画珍品之夜 · 古代',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/daguangudai/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/36c62f7ebdc030fa6dc1af8113a7abaa.jpg'
            },{
                name:'中国近现代书画',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/zhongguojinxiandaishuhua/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/ca07dd3c058256172db49453ef4ab282.jpg'
            },{
                name:'中国古代书画',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/gudaishuhua/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/6bdea0235efac0a41a22197ba2126878.jpg'
            },{
                name:'中国当代书画',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/dangdaishuhua/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/c7dbf1b6157e882fbbe7b28e6e898fb4.jpg'
            },{
                name:'一片丹青紫云开—星洲张美寅珍藏名家画壶',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zhongguojiade/yipiandanqingziyunkai/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/c545896ddda9e60e15ece758629f9919.jpg'
            },{
                name:'笔墨文章—信札写本专场',
                link:'https://podshare.artron.net/beijing/2025chun/zhongguojiade/bimowenzhang/mobile/index.html',
                imgUrl:'https://img13.artimg.net/public/cms-cloud/jpg/202505/3e85c85a939d61f291f5f7f38ba9210f.jpg'
            },{
                name:'古籍善本 金石碑帖',
                link:'https://podshare.artron.net/beijing/2025chun/shengshidongfang/gujishanben123/mobile/index.html',
                imgUrl:'https://img11.artimg.net/public/cms-cloud/jpg/202505/b7848f80440a2fe1ba35b05d5eb1db94.jpg'
            },{
                name:'国酿醇香—贵州茅台酒臻品',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zgjiadesan/jiu/mobile/index.html',
                imgUrl:'https://img12.artimg.net/public/cms-cloud/jpg/202505/37339263cade4d8a4979b04a3c7aa761.jpg'
            },{
                name:'至味茗香—陈年普洱茶及佳茗',
                link:'https://podshare.artron.net/shenzhen/2025chunpai/zgjiadesan/chaye/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/dcfda4657f5e295be831e4a2c09a8e3c.jpg'
            },{
                name:'造微入妙—邮品 钱币',
                link:'https://podshare.artron.net/beijing/2025chun/JD/youpin/mobile/index.html',
                imgUrl:'https://img10.artimg.net/public/cms-cloud/jpg/202505/b4eb997235402a271750ac965bd8dabb.jpg'
            },{
                name:'造微入妙—球星卡专场',
                link:'https://podshare.artron.net/beijing/2025chun/JD/QIUXINGKA/mobile/index.html',
                imgUrl:'https://img14.artimg.net/public/cms-cloud/jpg/202505/f80d7216e1fb20dca99749be22db9e87.jpg'
            }

            ],
        }
    },
    mounted() {
        document.title = '中国嘉德2025春拍';
        window.AFedWxShareData = {
            title: '中国嘉德2025春季拍卖会电子书 - 雅昌拍卖图录APP',
            imgUrl: 'https://thumb2.artron.net/Img/image?w=315&h=420&f4=1&src=https://img11.artimg.net/public/beian/jpg/202504/9a7fec09a55ec4af0a47048568d274e5.jpg',
            desc: '中国嘉德2025春拍',
            link: window.location.href
        }
        getWXConfig(window.AFedWxShareData)
        this.screenWidth = Math.floor((window.innerWidth*0.8-50)/150);
        window.addEventListener('resize', this.handleResize);
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
           this.isPC=false
        } else {
            this.isPC=true
        }
        // if(this.getCookie('activeBookcase')){
        //     this.active= this.getCookie('activeBookcase')
        // }else{
        //     this.active= '2'
        // }

        this.active= '2'

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {

        changeTab(){
            this.setCookie('activeBookcase',this.active)

            if(this.active==2){
                this.listJson=this.list2

            }else{
                this.listJson=this.list1
            }
        },
        handleResize() {
            this.screenWidth = Math.floor((window.innerWidth*0.8-50)/150);
        // 在这里执行你的逻辑
        },
        goLink(e){
            window.location.href = e;
        },

        // 获取cookie
        getCookie(name) {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith(name + '=')) {
                    return decodeURIComponent(cookie.substring(name.length + 1));
                }
            }
            return null;
        },

        // 设置cookie
        setCookie(name, value, days = 30, path = '/') {
            let expires = '';
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=' + path;
        }

    }
}
</script>
<style lang="scss" scoped>
.bookcase{
   background:#F1D8B9;
   width: 100%;
   padding: 0 12px;
   box-sizing: border-box;
   .barTop{
      width: 100%;
      height: 54px;
      background: url('../../assets/img/bookcase/bg.png') no-repeat center;
      background-size: cover;
      display: flex;
      justify-content:space-between;
      align-items:center;
      padding: 0 14px;
      box-sizing: border-box;
      .logo{
        width: 122px;
      }
      .title{
        width: 141px;
      }
   }
   .bookBox{
      width: 100%;
      min-height: 100vh;
      background: url('../../assets/img/bookcase/bg_2.png') no-repeat center;
      background-size: cover;
      position: relative;
      display: flex;
      justify-content:space-between;
      padding-bottom: 33px;
      .bookBottom{
        width: 100%;
        height: 167px;
        position:absolute;
        bottom: 0;
        z-index: 2;
        left: 0;
        .bookBottomImg{
            position: absolute;
            bottom: -6px;
            left: 0;
            width: 100%;
            z-index: 5;
            height: 176px;
            background: url('../../assets/img/bookcase/bottom_mid.png') ;
            background-repeat: repeat-x;
            background-size: cover;
        }
        img{
            position: absolute;
            width: 128px;

        }
      }

      .leftColumn{
        width: 22px;
        height: 100%;
        background: url('../../assets/img/bookcase/leftColumn.png') repeat center;
        background-size: cover;
      }
      .rightColumn{
        width: 22px;
        height: 100%;
        background: url('../../assets/img/bookcase/rightColumn.png') repeat center;
        background-size: cover;
      }
      .pcText{
        /deep/.van-tab__text{
            font-size: 14px !important;
        }
      }
      .listBox{
        width: 100%;
        height: 100%;
        background: url('../../assets/img/bookcase/bg_2.png') repeat center;
        background-size: cover;
        position: relative;
        padding-top: 2rem;
        .listTab{
            position: absolute;
            z-index: 10;
            width: calc(100% - 2rem);
            top: 0.5rem;
            left: 1rem;
            border-bottom: 0.05rem solid #996A44;
            .tabClass{
                /deep/.van-tabs__nav{
                    background: transparent !important;
                }
                /deep/.van-tab__text{
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 0.75rem;
                    color: rgba(255,235,216,0.6);
                }
                /deep/.van-tab--active .van-tab__text{
                    font-weight: 600  !important;
                    color: #FFF3E7  !important;
                }
                /deep/.van-tabs__line{
                    width: 5.5rem;
                    height: 0.1rem;
                    background-color:  #FAEEE2;
                }
                /deep/.van-tabs__nav{
                    border-bottom: 0.05rem solid #996A44;
                }


            }
        }
        .lastRow:last-child{
            justify-content:flex-start;

            .bookItem{
                margin-right: 5%;
            }
        }
        .bookshelfBox{
            z-index: 5;
            margin: 0 auto;
            padding-top: 65px;
            width: 80%;
            height:190px;
            position: relative;
            background: url('../../assets/img/bookcase/bookshelf_mid.png') repeat-x;
            background-size: 100% 55px;
            background-position: bottom;
            display: flex;
            justify-content: space-between;
            .bookItem{
                position: relative;
                width: 110px;
                .bookImg{
                    width: 110px;
                    height: 140px;
                    border-radius: 3px 3px 3px 3px;
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.65);
                    .bookImgMask{
                        position:absolute;
                        width: 100%;
                        height: 100%;
                        z-index: 2;
                        background:linear-gradient(270deg, rgba(0, 0, 0, 0) 90%, #000000 110%)

                    }


                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .bookName{
                        width: 126px;
                        position: absolute;
                        bottom:45px;
                        left: -8px;
                        z-index: 6;
                        background: linear-gradient( 180deg, rgba(96,59,34,0.7) 0%, #CEA67D 100%);
                        border-radius: 5px 5px 5px 5px;
                        border: 1px solid #FFD5AB;
                        font-family: PingFang SC, PingFang SC;
                        line-height: 25px;
                        text-align: center;
                        font-weight: 400;
                        font-size: 12px;
                        color: #FFF6E1;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1; /* 限制文本为2行 */
                        overflow: hidden;
                }

            }
            &::before{
                content: "";
                position: absolute;
                width: 30px;
                height: 55px;
                bottom: 0px;
                left: -30px;
                background: url('../../assets/img/bookcase/bookshelf_left.png') repeat center;
                background-size: cover;
            }
            &::after {
                content: "";
                position: absolute;
                width: 30px;
                height: 55px;
                bottom: 0;
                right:-30px;
                background: url('../../assets/img/bookcase/bookshelf_right.png') repeat center;
                background-size: cover;
            }
        }
        .bgMask{
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            min-height: 100vh;
            background: rgba(222,183,141,0.67);
            box-shadow: inset 0px -16px 143px 0px rgba(114,63,0,0.79);
            position: absolute;
            z-index: 1;
        }
      }

   }
}

</style>
